import { ClientHistoryRepository } from "@domain/repositories/ClientHistoryRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { ClientHistory } from "@domain/models/ClientHistory";

type Input = Client["id"];

type Output = Promise<ClientHistory[]>;

export class GetClientHistoryUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientHistoryRepository: ClientHistoryRepository) {}

  execute(clientId: Input) {
    return this.clientHistoryRepository.getClientHistory(clientId);
  }
}
